import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../componentLibrary/Button";
import MissionTab from "./components/MissionTab";
import TeamsTab from "./components/TeamsTab";
import PrivacyTab from "./components/PrivacyTab";

const AboutUsPage = () => {
  const [selectedTab, setSelectedTab] = React.useState<string>("mission");
  const navigate = useNavigate();

  return (
    <div className="flex justify-center">
      <div className="w-full max-w-sm lg:max-w-2xl mt-12 sm:mt-2 px-4 space-y-4 mb-10">
        <div>
          <h2>About Us</h2>
          <hr />
        </div>
        <div className="flex justify-between gap-2 h-12">
          <Button
            variant={selectedTab === "mission" ? "primary" : "secondary"}
            className="flex-1 h-full"
            size="sm"
            onClick={() => setSelectedTab("mission")}
          >
            Our Values
          </Button>
          <Button
            variant={selectedTab === "team" ? "primary" : "secondary"}
            className="flex-1 h-full"
            size="sm"
            onClick={() => setSelectedTab("team")}
          >
            Our Team
          </Button>
        </div>
        {selectedTab === "mission" && <MissionTab />}
        {selectedTab === "team" && <TeamsTab />}
        {selectedTab === "privacy" && <PrivacyTab />}

        {/* Story Link Section */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="text-center">
            <p className="text-sm lg:text-base text-gray-600 mb-4">
              Click to learn more about the Psych for Life<sup>®</sup> story...
            </p>
            <Button
              variant="secondary"
              onClick={() => navigate("/landing#story")}
              className="px-6 py-2 mx-auto block"
            >
              Read Our Story
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
